import { Heading, RichText, Icon, Paragraph } from 'ui/components';
import styles from './ProductDescriptionTab.module.scss';
import classNames from 'classnames';
import ChevronIcon from 'ui/icons/icon-chevron.svg';
import { useState } from 'react';

export interface ProductDescriptionTabProps {
	id?: string;
	title?: string;
	text?: string;
	isActive?: string;
	setIsActive?: React.Dispatch<React.SetStateAction<string>>;
	safetyDatasheets?: { countryCode: string; url: string }[];
	productName?: string;
	dictionary: { [key: string]: string };
	countryChosen?: boolean;
}

export const ProductDescriptionTab: React.FC<ProductDescriptionTabProps> = ({
	title,
	id,
	text,
	isActive,
	setIsActive,
	safetyDatasheets,
	productName,
	dictionary,
	countryChosen,
}) => {
	const [mobileActive, setMobileActive] = useState(false);

	return (
		<div
			className={classNames(styles.ProductDescriptionTab, isActive === id ? styles.isActive : '')}
			onClick={() => {
				setIsActive(id);
				setMobileActive(!mobileActive);
			}}
		>
			<div className={styles.ProductDescriptionTab_header}>
				<Heading headingLevel="h3" style="sm">
					{title}
				</Heading>
				{/* MOBILE ONLY */}
				<div className={styles.ProductDescriptionTab_buttonIconContainer}>
					<Icon
						size="xl"
						className={classNames(styles.ProductDescriptionTab_buttonIcon, {
							[styles.mobileActive]: mobileActive,
						})}
					>
						<ChevronIcon />
					</Icon>
				</div>
			</div>
			<div
				className={classNames(styles.ProductDescriptionTab_tabText, {
					[styles.mobileActive]: mobileActive,
				})}
			>
				<RichText content={text} />
				{safetyDatasheets?.length > 0 &&
					(countryChosen ? (
						<div className={styles.ProductDescriptionTab_safetyDataSheet}>
							<p>{dictionary.downloadSafetyDataSheet}</p>
							{safetyDatasheets.map((safetyDatasheet, index) => (
								<div key={index}>
									<a
										href={safetyDatasheet.url}
										className={classNames(styles.ProductDescriptionTab_safetyDataSheetLink, styles[`Link___primary`])}
									>
										{safetyDatasheet.countryCode} - {dictionary.safetyDataSheet}: {productName}
									</a>
								</div>
							))}
						</div>
					) : (
						<Paragraph className={styles.ProductDescriptionTab_safetyDataSheetText} style="md">
							{dictionary.chooseCountryToDownload}
						</Paragraph>
					))}
			</div>

			{/* MOBILE ONLY END */}
		</div>
	);
};
